export default {
  title: 'Chargenwerte löschen',
  confirmDelete: {
    header: 'Entfernen von Daten bestätigen',
    message: 'Bitte bestätige das Löschen der Chargenwerte im Zeitraum von {from} bis {to} für "{item}".',
  },
};
